import { Component, Prop, Vue, Mixins } from 'vue-property-decorator';
import store from "Store/index"
import { mixins } from 'vue-class-component';
import BaseComponent from 'Components/Base/ABaseComponent';
import OrderingListUserMixin from 'Mixins/OrderingListUserMixin';

@Component({})
export default class OrderingListRequestProductConditionComponent extends mixins(BaseComponent, OrderingListUserMixin) {

    @Prop()
    public productKey: string;
    
    async created(){
        this.setLoading();
        await store.dispatch.auth.loadUser();
        this.setLoaded();
    }


    get isRestricted(){             
        return !this.isAdvancedAdmin && (this.isAdmin || this.isEmployee);
    }


    get isAvailable(): boolean{
        return this.currrentOrderingList && this.currrentOrderingList.items && this.currrentOrderingList.items.find(x => x.productKey == this.productKey) != null;
    }

    get currrentOrderingList()
    {
        return store.state.orderingList.currentOrderingList;
    }
    
    
}

Vue.component('ordering-list-request-product-condition', OrderingListRequestProductConditionComponent);